import Vue from "vue";
import gaService from "./ga.service";

export default {
    async getGamesAsync() {
        return (await Vue.http.get("/api/komplexbridge/games")).data;
    },
    async openSession(options = { lang: "en", game }) {
        const gameId = "KomplexBridge";
        gaService.send("games", "komplexbridge", gameId);
        return (await Vue.http.post("/api/komplexbridge/session/open", Object.assign({}, options))).data;
    },
    async openDemoSession(options = { lang: "en", game }) {
        const gameId = "KomplexBridge";
        gaService.send('games-demo', 'komplexbridge', gameId);
        return (await Vue.http.post('/api/komplexbridge/session/opendemo', Object.assign({}, options))).data;
    },
    async closeSession() {
        return (await Vue.http.post("/api/komplexbridge/session/close")).data;
    }
};


// WEBPACK FOOTER //
// ./_common/services/komplexbridge.service.js